import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import '../components/Header.css'; // 复用 Header 的样式

/**
 * Universal Link 中转页面
 * 当用户在浏览器中访问 /wave/:id 或 /profile/:id 时显示
 */
export const UniversalLinkPage = () => {
    const { id } = useParams();
    const location = useLocation();
    const appStoreUrl = 'https://apps.apple.com/us/app/marlo-connect-meet-nearby/id6450737280?l=zh-Hans-CN';
    
    // 根据路径构建 URL Scheme
    const getUrlScheme = () => {
        if (location.pathname.startsWith('/wave/')) {
            return `marlo://wave/${id}`;
        } else if (location.pathname.startsWith('/profile/')) {
            return `marlo://profile/${id}`;
        }
        return 'marlo://';
    };
    
    const urlScheme = getUrlScheme();
    
    // 页面加载时自动尝试打开 App
    useEffect(() => {
        // 尝试使用 URL Scheme 打开 App
        const attemptToOpenApp = () => {
            // 创建隐藏的 iframe 尝试打开 App
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = urlScheme;
            document.body.appendChild(iframe);
            
            // 清理 iframe
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 1000);
        };
        
        attemptToOpenApp();
    }, [urlScheme]);

    return (
        <div className="download-modal-overlay" style={{ position: 'fixed', zIndex: 9999 }}>
            <div className="download-modal-content">
                <div className="download-modal-body">
                    <img 
                        src={require('../images/download/qr.png')} 
                        alt="QR Code" 
                        className="qr-code"
                    />
                    <div className="download-or-text">OR</div>
                    <img 
                        src={require('../images/download/store.png')} 
                        alt="App Store" 
                        className="store-badge"
                        onClick={() => window.open(appStoreUrl, '_blank')}
                        style={{ cursor: 'pointer' }}
                    />
                    <h3 className="download-title">Download Marlo</h3>
                    <p className="download-description">
                        Download to make friends and<br/>have fun anytime, any where.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UniversalLinkPage;
